export const adaptCondicionesGeneralesRI = ({ condicionGeneralRIByID }) => {
    const condicionesGenerales = condicionGeneralRIByID;

    return {
        idDatosGeneralesRI: condicionesGenerales?.idDatosGeneralesRI,
        condicionesGenerales1: {
            idCondicionGeneralRI: condicionesGenerales.idCondicionGeneralRI,
            buenaTolerancia: condicionesGenerales.buenaTolerancia,
            continuarOtroTratamiento: condicionesGenerales.continuarOtroTratamiento,
            descOtroTratamiento: condicionesGenerales.descOtroTratamiento,
            inicioDeServicio: condicionesGenerales.inicioDeServicio,
            justificacionNoInicio: condicionesGenerales.justificacionNoInicio,
            dispositivoParaVideoConf: condicionesGenerales.dispositivoParaVideoConf,
            idComboRIValorFasePaciente: condicionesGenerales.idComboRIValorFasePaciente
        },
        condicionesGenerales2: {
            idCondicionGeneralRI: condicionesGenerales.idCondicionGeneralRI,
            domicilioAccesible: condicionesGenerales.domicilioAccesible,
            aguaPotable: condicionesGenerales.aguaPotable,
            redElectrica: condicionesGenerales.redElectrica,
            comprendeAceptaServicio: condicionesGenerales.comprendeAceptaServicio,
            higiene: condicionesGenerales.higiene,
            internacionDomiciliaria: condicionesGenerales.internacionDomiciliaria,
            cuidador: condicionesGenerales.cuidador,
            almacenamiento: condicionesGenerales.almacenamiento,
            prestacion: condicionesGenerales.prestacion,
            empresa: condicionesGenerales.empresa,
            observaciones: condicionesGenerales.observaciones
        },
        condicionesGenerales3: {
            idCondicionGeneralRI: condicionesGenerales.idCondicionGeneralRI,
            higieneInstitucion: condicionesGenerales.higieneInstitucion,
            almacenamientoInstitucion: condicionesGenerales.almacenamientoInstitucion,
            personalInstitucion: condicionesGenerales.personalInstitucion,
            evaluacionFamiliaPsicosocial: condicionesGenerales.evaluacionFamiliaPsicosicial,
            conclusion: condicionesGenerales.conclusion,
            consentimientoInformado: condicionesGenerales.consentimientoInformado,
            consentimientoInput: condicionesGenerales?.consentimientoOutput ? {
                contentType: condicionesGenerales?.consentimientoOutput?.contentType,
                titulo: condicionesGenerales?.consentimientoOutput?.titulo,
                archivo: condicionesGenerales?.consentimientoOutput?.archivo,
                extension: condicionesGenerales?.consentimientoOutput?.extension
            } : null,
            fechaFirmaConsentimiento: condicionesGenerales.fechaFirmaConsentimiento
        }
    }
}